import type {Recipe} from './types';

export const cremaMascarpone: Recipe = {
    id: 1,
    key: "cremaMascarpone",
    pictures: [
        {index: 0, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2021/10/Crema-al-mascarpone-1200x675.jpg"},
        {index: 1, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2021/10/Crema-al-mascarpone_preparare_sciroppo_2.jpg"},
        {index: 2, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2021/10/Crema-al-mascarpone_raggiungere_temperatura_3.jpg"},
        {index: 4, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2021/10/Crema-al-mascarpone_versare_sciroppo_4.jpg"},
        {index: 6, url: "https://staticcookist.akamaized.net/wp-content/uploads/sites/21/2021/10/Crema-al-mascarpone_aggiungere_montata_7.jpg"},
    ],
    i18n: {
        IT: {
            title: "Crema di Mascarpone",
            servings: "Quantità per diverse porzioni",
            ingredients: [
                "250 gr di mascarpone",
                "2 tuorli ",
                "60 gr di zucchero ",
                "25 gr di acqua",
            ],
            steps: [
                "Inizia dalla preparazione della pate à bombe. Versa lo zucchero e l'acqua in un pentolino e porta sul fuoco.",
                "Utilizza un termometro da cucina per monitorare la temperatura dello sciroppo fino a 121 °C. Se non disponi di un termometro, la temperatura è ottimale quando sulla superficie dello sciroppo si formano tante bollicine.",
                "A 114-115 °C, separa gli albumi dai tuorli, monta i tuorli con le fruste elettriche.",
                "Versa lo sciroppo sui tuorli montati, continuando a montare fino al completo raffreddamento.",
                "Lavora il mascarpone in una ciotola separata usando una spatola.",
                "Aggiungi gradualmente la montata di uova pastorizzate.",
                "Mescola delicatamente dal basso verso l'alto per non smontare il composto.",
                "Dovrai ottenere una crema liscia e vellutata, priva di grumi.",
                "La crema al mascarpone è pronta: può essere servita in bicchierini o utilizzata per farcire torte o preparare il tiramisù.",
            ],
            notes: "Per pastorizzare le uova e realizzare lo sciroppo di zucchero è importante usare un termometro preciso. La crema si conserva in frigo per massimo 3 giorni.",
        },
        EN: {
            title: "Mascarpone Cream",
            servings: "Quantity for several servings",
            ingredients: [
                "250 g mascarpone",
                "2 egg yolks",
                "60 g sugar",
                "25 g water",
            ],
            steps: [
                "Start by preparing the pâte à bombe. Pour the sugar and water into a small saucepan and place it on the heat.",
                "Use a kitchen thermometer to monitor the temperature of the syrup until it reaches 121 °C. If you don't have a thermometer, the optimal temperature is reached when many bubbles form on the surface of the syrup.",
                "At 114-115 °C, separate the egg whites from the yolks and beat the yolks with an electric whisk.",
                "Pour the syrup over the beaten yolks, continuing to beat until completely cooled.",
                "Work the mascarpone in a separate bowl using a spatula.",
                "Gradually add the pasteurized egg mixture.",
                "Mix gently from bottom to top to avoid deflating the mixture.",
                "You should obtain a smooth and velvety cream, free of lumps.",
                "The mascarpone cream is ready: it can be served in small glasses or used to fill cakes or prepare tiramisu.",
            ],
            notes: "To pasteurize the eggs and make the sugar syrup, it is important to use a precise thermometer. The cream can be stored in the refrigerator for up to 3 days.",
        },
        PL: {
            title: "Krem z Mascarpone",
            servings: "Ilość na kilka porcji",
            ingredients: [
                "250 g mascarpone",
                "2 żółtka",
                "60 g cukru",
                "25 g wody",
            ],
            steps: [
                "Zacznij od przygotowania pâte à bombe. Wlej cukier i wodę do małego rondelka i postaw na ogniu.",
                "Użyj termometru kuchennego, aby monitorować temperaturę syropu, aż osiągnie 121 °C. Jeśli nie masz termometru, optymalna temperatura jest wtedy, gdy na powierzchni syropu pojawia się wiele bąbelków.",
                "Przy 114-115 °C oddziel białka od żółtek i ubij żółtka mikserem elektrycznym.",
                "Wlej syrop na ubite żółtka, kontynuując ubijanie, aż do całkowitego ostygnięcia.",
                "Pracuj mascarpone w oddzielnej misce, używając szpatułki.",
                "Stopniowo dodawaj pasteryzowaną mieszankę jajek.",
                "Delikatnie mieszaj od dołu do góry, aby nie zniszczyć konsystencji.",
                "Powinieneś uzyskać gładki i aksamitny krem, bez grudek.",
                "Krem z mascarpone jest gotowy: można go podawać w małych szklankach lub używać do nadziewania ciast lub przygotowania tiramisu.",
            ],
            notes: "Aby pasteryzować jajka i przygotować syrop cukrowy, ważne jest użycie precyzyjnego termometru. Krem można przechowywać w lodówce do 3 dni.",
        },
    },
};
